export default "__VITE_ASSET__CYTxR64l__"